import { useCallback, useContext } from 'react';
import { WorkspaceManagementContext } from '../app/contexts/workspace/workspace-management-context';
import { MapGotoTarget } from '../common/enums';
import { useAppSelector } from '../app/hooks/store-hooks';
import Coordinate from '../common/coordinate';
import { FlightSelectCallbackOptions } from '@fe/flight-layer';

export function useGotoTargetMaps() {
    const workspaceContext = useContext(WorkspaceManagementContext);
    const workspaceState = useAppSelector((x) => x.workspace);
    const mapGotoTargetMode = useAppSelector((x) => x.settings.mapGotoTargetMode);

    const checkMapTargetSettings = useCallback(
        (workspaceId: number) => {
            if (mapGotoTargetMode === MapGotoTarget.active) {
                return workspaceState.selectedId === workspaceId;
            }

            if (mapGotoTargetMode == MapGotoTarget.map0) {
                return workspaceId === 0;
            }

            if (mapGotoTargetMode == MapGotoTarget.map1) {
                return workspaceId === 1;
            }

            if (mapGotoTargetMode == MapGotoTarget.map2) {
                return workspaceId === 2;
            }

            if (mapGotoTargetMode == MapGotoTarget.map3) {
                return workspaceId === 3;
            }

            return true;
        },
        [mapGotoTargetMode, workspaceState]
    );

    return {
        goToAirport: (position: Coordinate) =>
            workspaceContext.items.filter((x) => checkMapTargetSettings(x.id)).forEach((x) => x.map?.goToAirport(position)),

        goToFlight: (id: number, options: FlightSelectCallbackOptions) => {
            const targetContexts = workspaceContext.items.filter((x) => checkMapTargetSettings(x.id));
            for (const context of targetContexts) {
                // Select for active workspace
                if (context.id === workspaceState.selectedId) {
                    context.flightLayerFacade.selection.selectFlight(id, options);
                }
                // Goto for others
                else {
                    const flight = context.flightLayerFacade.flights.getFlight(id);
                    if (flight) {
                        const { currentPosition, speed } = flight;
                        const zoom = speed != null && speed < 50 ? 14 : speed != null && speed < 200 ? 10 : 6;
                        context.map?.goToFlight(Coordinate.fromArray(currentPosition as [number, number]), zoom);
                    }
                }
            }
        },

        isActiveWorkspaceInTarget: () => checkMapTargetSettings(workspaceState.selectedId)
    };
}
